import { HoverTooltip, HoverTooltipPosition } from "@nova/component-hover-tooltip"
import { useTranslation } from "@nova/use-translation"
import { Viewer } from "@photo-sphere-viewer/core"
import { MutableRefObject } from "react"

type CompassProps = {
    bearing: number
    compassRef: MutableRefObject<null>
    viewer: Viewer | null
}
export const Compass = ({ bearing, compassRef, viewer }: CompassProps) => {
    const { t } = useTranslation()

    return bearing != null && !Number.isNaN(bearing) ? (
        <div className="rounded-xl cursor-pointer" ref={compassRef}>
            <svg
                onClick={() =>
                    viewer?.rotate({
                        yaw: 0,
                        pitch: 0,
                    })
                }
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect width="24" height="24" rx="12" fill="#333333" fillOpacity="0.9" />
                <circle cx="12" cy="12" r="11.5" stroke="#5A5A5A" />
                <path
                    d="M12 1.5791L12 4.5791"
                    stroke="#5A5A5A"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                />
                <path
                    d="M12 19.5791L12 22.5791"
                    stroke="#5A5A5A"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                />
                <path
                    d="M1.5 12.0791H4.5"
                    stroke="#5A5A5A"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                />
                <path
                    d="M19.5 12.0791H22.5"
                    stroke="#5A5A5A"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                />
                <g
                    style={{
                        transform: `rotate(${-bearing}deg)`,
                        transformOrigin: "center",
                    }}
                >
                    <path
                        d="M9.82444 12.083L11.843 5.67694C11.8982 5.5016 12.1466 5.50224 12.2009 5.67786L14.1815 12.0781L9.82444 12.083Z"
                        fill="#F15D4F"
                    />
                    <path
                        d="M14.1785 12.0771L12.1599 18.4831C12.1047 18.6585 11.8563 18.6578 11.802 18.4822L9.82148 12.0819L14.1785 12.0771Z"
                        fill="white"
                    />
                    <circle
                        cx="12.001"
                        cy="12.0786"
                        r="0.75"
                        transform="rotate(45 12.001 12.0786)"
                        fill="#687074"
                    />
                </g>
            </svg>
            <HoverTooltip
                id="plugin-tooltip"
                parentRef={compassRef}
                style={{
                    textAlign: "center",
                    color: "black",
                    padding: "8px",
                    fontSize: "12px",
                }}
                borderColor="#00000026"
                hoverTimeoutDelay={0}
                hoverStartDelay={1000}
                hoverTooltipPosition={HoverTooltipPosition.bottomRight}
                containerClassName="-translate-y-[80px] -translate-x-[50px]"
            >
                {t("Reset View")}
            </HoverTooltip>
        </div>
    ) : null
}
